import { render, staticRenderFns } from "./PuzzleImageFramed.vue?vue&type=template&id=b1a8b680&scoped=true&"
import script from "./PuzzleImageFramed.vue?vue&type=script&lang=ts&"
export * from "./PuzzleImageFramed.vue?vue&type=script&lang=ts&"
import style0 from "./PuzzleImageFramed.vue?vue&type=style&index=0&id=b1a8b680&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8b680",
  null
  
)

export default component.exports